var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main",class:{ 'person-scrollbar': _vm.$route.name === 'Person' },attrs:{"id":"AppMain"}},[_c('div',{staticClass:"app-main-wrap"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }